import { useEffect, useState } from "react";
import "./Tables.scss";
import Loader from "../../../common/components/Loader";
import { Link } from "react-router-dom";
import { MFButton } from "../../../common/components/MFButton";
import Paginator from "../../../common/components/Paginator";
import FoldersTable from "../../folders/containers/FoldersTable";
import CalculsTable from "../containers/CalculsTable";
import { ModalManageFolder } from "../../folders/components/modals/ModalManageFolder";
import SearchInput from "../../../common/components/SearchInput";
import { Gear } from "../../../assets/icons/Gear";
import { Filter } from "../../../assets/icons/Filter";
import CalculsFooterActions from "../containers/CalculsFooterActions";
import { defaultCalculsFilters } from "../constants";
import CalculsFilters from "../containers/CalculsFilters";
import { CalculsFiltersBanner } from "./filters/CalculsFiltersBanner";
import { normalizePaginationLimit } from "../../../common/constants/pagination";

const Calculs = ({
  calculs,
  loadUserCalculs,
  isGeneratingReports,
  calculsCurrentPage,
  calculsTotal,
  calculsLimit,
  isCalculsLoading,
  getLocalEDECIntegration,
  localConfigurator,
  isExportLoading,
  exportCalculsXlsx,
  updateCalculsLimit,
  changeCalculsPage,
  isFoldersLoading,
  foldersCurrentPage,
  foldersLimit,
  foldersTotal,
  updateFoldersLimit,
  changeFoldersPage,
  loadUserFolders,
  createFolder,
  changeCalculsSearch,
  calculsSearch,
  isDownloadingReports,
  openCalculsFiltersSection,
  isFilterSectionOpen,
  closeCalculsFiltersSection,
  calculsFilters,
  updateCalculsFilters,
}) => {
  const [isManageFolderModalOpen, setIsManageFolderModalOpen] = useState(false);
  const [selectedCalculs, setSelectedCalculs] = useState([]);

  const selectedTab = !window.location.hash
    ? "calculs"
    : window.location.hash === "#folders"
      ? "folders"
      : "calculs";
  const safeCalculsLimit = normalizePaginationLimit(calculsLimit);
  const safeFoldersLimit = normalizePaginationLimit(foldersLimit);
  const selectedLimit =
    selectedTab === "calculs" ? safeCalculsLimit : safeFoldersLimit;

  useEffect(() => {
    if (selectedCalculs.length === 0 || !calculs?.length) return;
    setSelectedCalculs((prev) =>
      prev.map((selected) => {
        const updated = calculs.find((c) => c._id === selected.id);
        if (!updated) return selected;
        return {
          ...selected,
          folderIds: updated.folders?.map((f) => f._id) || [],
        };
      }),
    );
  }, [calculs]); // eslint-disable-line

  useEffect(() => {
    closeCalculsFiltersSection();
    loadUserFolders();
    if (!isGeneratingReports) {
      loadUserCalculs();
    }
  }, []); // eslint-disable-line

  // useEffect(() => {
  //   const handleHashChange = () => closeCalculsFiltersSection();
  //   window.addEventListener("hashchange", handleHashChange);
  //   return () => window.removeEventListener("hashchange", handleHashChange);
  // }, [closeCalculsFiltersSection]);

  useEffect(() => {
    if (localConfigurator.id) {
      getLocalEDECIntegration();
    }
  }, [localConfigurator.id]); //eslint-disable-line

  function handleCalculsPageChange(page) {
    if (page === calculsCurrentPage) return;
    changeCalculsPage(page);
  }

  function handleFoldersPageChange(page) {
    if (page === foldersCurrentPage) return;
    closeCalculsFiltersSection();
    changeFoldersPage(page);
  }

  return (
    <div
      className={`custom-table-container ${selectedTab === "calculs" && selectedCalculs.length > 0 ? "has-calcul-footer" : ""}`}
    >
      <Loader
        isActive={
          isCalculsLoading ||
          isFoldersLoading ||
          (isGeneratingReports && selectedCalculs.length > 0) ||
          isDownloadingReports
        }
        text={
          isGeneratingReports
            ? "Génération en cours..."
            : isDownloadingReports
              ? "Téléchargement en cours..."
              : undefined
        }
      />
      <div className="table-inner-content">
        <div
          className="d-flex justify-content-between mt-2 mb-2 mx-1 align-items-end"
          style={{ height: 40 }}
        >
          <div>
            <ul className="nav nav-tabs nav-underline">
              <li className="nav-item">
                <a
                  className={`nav-link ${selectedTab === "calculs" ? "active" : ""}`}
                  aria-current="page"
                  href="#calculs"
                >
                  Tous mes calculs
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${selectedTab === "folders" ? "active" : ""}`}
                  href="#folders"
                >
                  Dossiers
                </a>
              </li>
            </ul>
          </div>
          {selectedTab === "calculs" && (
            <div>
              {exportCalculsXlsx && (
                <MFButton
                  className="mr-1"
                  onClick={exportCalculsXlsx}
                  disabled={isExportLoading}
                  height={30}
                >
                  Exporter ce tableau au format Excel
                </MFButton>
              )}
              <Link to="/?referer=calculs" className="mr-1">
                <MFButton height={30}>Nouveau calcul</MFButton>
              </Link>
              <Link to="/calculs/parameters">
                <MFButton height={30} width={30} outlined>
                  <Gear size={20} />
                </MFButton>
              </Link>
            </div>
          )}
          {selectedTab === "folders" && (
            <div>
              <MFButton
                height={30}
                onClick={() => setIsManageFolderModalOpen(true)}
              >
                Nouveau dossier
              </MFButton>
            </div>
          )}
        </div>
        {selectedTab === "calculs" ? (
          <>
            <div
              className="d-flex align-items-center search-input-container mx-1"
              style={{ marginBottom: 24 }}
            >
              <div className="w-100 mr-1">
                <SearchInput
                  search={calculsSearch}
                  setSearch={changeCalculsSearch}
                  placeholder="Rechercher un calcul"
                />
              </div>
              <MFButton
                height={38}
                outlined
                onClick={openCalculsFiltersSection}
                style={{ borderRadius: 6 }}
                className="d-flex align-items-center"
              >
                <span className="d-flex align-items-center position-relative">
                  {JSON.stringify(calculsFilters) !==
                    JSON.stringify(defaultCalculsFilters) && (
                    <div className="filter-button-badge text-interaction" />
                  )}
                  <Filter size={16} />
                </span>
                <span style={{ marginLeft: 8 }}>Filtrer</span>
              </MFButton>
            </div>
            <CalculsFiltersBanner
              filters={calculsFilters}
              updateFilters={updateCalculsFilters}
            />
            <CalculsTable
              selectedCalculs={selectedCalculs}
              setSelectedCalculs={setSelectedCalculs}
            />
          </>
        ) : (
          <FoldersTable />
        )}
      </div>

      <div className="pagination-footer" style={{ height: 60 }}>
        <div className="flex-center">
          <span className="text-secondary-black text-nowrap mr-1">
            Par page
          </span>
          <select
            name="calculs-per-page"
            className="form-control"
            value={selectedLimit}
            onChange={(event) => {
              if (selectedTab === "calculs") {
                updateCalculsLimit(event.target.value);
              } else {
                updateFoldersLimit(event.target.value);
              }
            }}
          >
            {[10, 20, 30, 40, 50].map((value) => (
              <option key={"per-page" + value} value={value}>
                {value}
              </option>
            ))}
          </select>
        </div>
        <Paginator
          total={selectedTab === "calculs" ? calculsTotal : foldersTotal}
          currentPage={
            selectedTab === "calculs" ? calculsCurrentPage : foldersCurrentPage
          }
          limit={selectedLimit}
          onPageChange={
            selectedTab === "calculs"
              ? handleCalculsPageChange
              : handleFoldersPageChange
          }
          maxWidth={600}
        />
      </div>

      {selectedTab === "calculs" && selectedCalculs.length > 0 && (
        <CalculsFooterActions
          selectedCalculs={selectedCalculs}
          setSelectedCalculs={setSelectedCalculs}
        />
      )}
      <CalculsFilters
        filters={calculsFilters}
        updateFilters={updateCalculsFilters}
      />
      <ModalManageFolder
        isOpen={isManageFolderModalOpen}
        onClose={() => setIsManageFolderModalOpen(false)}
        createFolder={createFolder}
      />
    </div>
  );
};

export default Calculs;
